import React from 'react';
import Col from 'react-bootstrap/Col';
import CartProduct from './CartProduct';

const CartList = (props) => {
    const {cart, removeCartItem, editOption} = props;

    return (
        <Col xs={12}>
           {cart.map( (item, k)=>
           <CartProduct 
                key={k}
                product={item}
                removeCartItem={removeCartItem}
                editOption={editOption}
           />
           )}
        </Col>
    );
}

export default CartList;